import React from "react";
import messages from "./messages";

import { FormattedMessage } from "react-intl";
import { useFavouriteItemsQuery } from "../../modules/favourites/api";
import {
  RecentlyCard,
  RecentlyCardDate,
  RecentlyCardImage,
  RecentlyCards,
  RecentlyCardsHeader,
  RecentlyCardsMore,
  RecentlyCardsTitle,
  RecentlyCardTitle,
} from "../RecentlyCards/index";
import { FavouriteItemType } from "../../modules/favourites/types";

export const RecentlyFavourites = () => {
  const { data: dataFavouriteItems = [] } = useFavouriteItemsQuery();

  const cards = React.useMemo(
    () =>
      dataFavouriteItems?.map((x) => {
        let to: string;
        switch (x.type) {
          case FavouriteItemType.Map:
            to = `/maps?favourite`;
            break;
          case FavouriteItemType.Slide:
            to = `/slides/${x.mark.reportId}?favourite`;
            break;
          case FavouriteItemType.BulkExport:
            to = `/bulk-export?favourite=${x.id}`;
            break;
          case FavouriteItemType.SavedBulkExport:
            to = `/bulk-export?savedFavourite=${x.id}`;
            break;
          default:
            to = "/favourites";
        }

        return {
          date: (x.date ? new Date(x.date) : new Date()).toDateString(),
          realDate: x.date,
          title: x.name,
          to,
          type: x.type,
        };
      }),
    [dataFavouriteItems]
  );
  if (cards.length === 0) {
    return null;
  }

  return (
    <RecentlyCards>
      <RecentlyCardsHeader>
        <RecentlyCardsTitle>
          <FormattedMessage {...messages.headerLabel} />
        </RecentlyCardsTitle>
        <RecentlyCardsMore to="/favourites">
          <FormattedMessage {...messages.headerMore} />
        </RecentlyCardsMore>
      </RecentlyCardsHeader>
      {cards
        .sort((a, b) => {
          const dateA = new Date(a.realDate).getTime();
          const dateB = new Date(b.realDate).getTime();
          return dateB - dateA;
        })
        .slice(0, 4)
        .map((card) => (
          <RecentlyCard to={card.to} openInNewTab key={card.to}>
            <RecentlyCardImage type={card?.type} />
            <RecentlyCardTitle>{card.title}</RecentlyCardTitle>
            <RecentlyCardDate>
              <FormattedMessage {...messages.dateLastOpened} />
              {card.date}
            </RecentlyCardDate>
          </RecentlyCard>
        ))}
    </RecentlyCards>
  );
};

export default RecentlyFavourites;
